import { GridFilterListIcon } from "@mui/x-data-grid";
import React from "react";
import SearchInputComponent from "../../../components/reusable-ui/search-input";

function TableHeader() {
  return (
    <div className="flex items-center justify-between p-24">
      <div>
        <div className="font-semibold text-xl">All Good Received Notes</div>
        <div className="opacity-60 font-400 text-14 mt-8">Head Office</div>
      </div>
      <div className="flex items-center justify-end gap-15">
        <div className="border select-none cursor-pointer active:brightness-75 active:bg-slate-100 border-solid flex items-center text-13 px-12 py-13 border-[#E8E8E9] rounded-[8px]">
          <GridFilterListIcon
            className="h-18 text-[#898989] w-18 mr-12"
            style={{}}
          />
          Filters
        </div>
        <SearchInputComponent
          placeholder={"Search good received notes"}
          customClass={"text-15 !py-14"}
          onSerachInput={() => {}}
          searchMinLength={3}
          elementWidthClass="min-w-[350px]"
          autoFocus={true}
        />
      </div>
    </div>
  );
}

export default TableHeader;
